import React from 'react';
import { CssBaseline, Box, Container, Grid, ThemeProvider, createTheme } from '@mui/material';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Trangchu from './components/Mainsite/Mainsite';
import Introduce from './components/Introduce/Introduce';
import WarDiary from './components/WarDiary/WarDiary';
import History from './components/History/History';
import AuthForm from './components/AuthForm/AuthForm';
import SearchPosts from './components/Search/SearchPosts';
import DashboardPage from './components/Dashboard/DashboardPage';
import ManageArticlesWrapper from './components/Dashboard/ManageArticles/ManageArticlesWrapper';
import ChangePassword from './components/Dashboard/ChangePassword';
import AddAdmin from './components/Dashboard/AddAdmin';
import ArticleDetail from './components/Article/ArticleDetail';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import AddArticles from './components/Dashboard/AddArticles';
import ScrollToTop from './extensions/ScrollToTop';
import Reply from './components/Reply/Reply';
import Feedback from './components/Feedback/Feedback';
import DashboardFeedback from './components/Dashboard/DashboardFeedback';
import DashboardReply from './components/Dashboard/DashboardReply';
import DashboardChangeBanner from './components/Dashboard/DashboardChangeBanner';
import AccountSettings from './components/AccountSettings/AccountSettings';
import FeelingDetail from './components/Reply/FeelingDetail';
import DashboardAccount from './components/Dashboard/DashboardAccount';

function AppContent() {
  const location = useLocation();
  const hideHeaderFooter = location.pathname.startsWith('/dashboard');
  const theme = createTheme();

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundColor: '#fbf7e4',
          minHeight: '100vh',
        }}
      >
        <CssBaseline />
        {!hideHeaderFooter && (
          <>
            <Header />
            <Box sx={{ height: { xs: 96, md: 168 } }} />
          </>
        )}
        <Routes>
          <Route path="/" element={<Trangchu />} />
          <Route path="/gioithieu" element={<Introduce />} />
          <Route path="/chienky" element={<WarDiary />} />
          <Route path="/luocsu" element={<History />} />
          <Route path="/login" element={<AuthForm />} />
          <Route path="/timkiem" element={<SearchPosts />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />
          <Route path="/hoiam" element={<Reply />} />
          <Route path="/phanhoi" element={<Feedback />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/:category" element={<ManageArticlesWrapper />} />
          <Route path="/feelings/:id" element={<FeelingDetail />} />
          <Route path="/dashboard/add" element={<AddArticles />} />
          <Route path="/dashboard/changepassword" element={<ChangePassword />} />
          <Route path="/dashboard/addadmin" element={<AddAdmin />} />
          <Route path="/dashboard/phanhoi" element={<DashboardFeedback />} />
          <Route path="/dashboard/hoiam" element={<DashboardReply />} />
          <Route path="/dashboard/banner" element={<DashboardChangeBanner />} />
          <Route path="/dashboard/accounts" element={<DashboardAccount />} />
        </Routes>
        {!hideHeaderFooter && <Footer />}
      </Box>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}